// src/render/canvas.ts -- DOM-bound
// Canvas dimensions track the sim world 1:1 so terrain renders pixel-perfect.
// 1600x900 — 16:9, fits Steam Deck (1280x800 letterbox), tablets, laptops, and
// 1080p monitors with room. Was 960x540 (mobile-first).
import { WORLD_W, WORLD_H } from '../sim/state';
export const GAME_W = WORLD_W;
export const GAME_H = WORLD_H;

export interface Renderer {
  screen: HTMLCanvasElement;
  sctx: CanvasRenderingContext2D;
  game: HTMLCanvasElement; // offscreen 480x270
  gctx: CanvasRenderingContext2D;
  terrainCanvas: HTMLCanvasElement; // separate, mutated via putImageData
  terrainCtx: CanvasRenderingContext2D;
}

export function createRenderer(screenEl: HTMLCanvasElement): Renderer {
  const sctx = screenEl.getContext('2d', { alpha: false })!;
  const game = document.createElement('canvas');
  game.width = GAME_W;
  game.height = GAME_H;
  const gctx = game.getContext('2d', { alpha: false })!;
  gctx.imageSmoothingEnabled = false;

  const terrainCanvas = document.createElement('canvas');
  terrainCanvas.width = GAME_W;
  terrainCanvas.height = GAME_H;
  const terrainCtx = terrainCanvas.getContext('2d')!; // alpha needed

  return { screen: screenEl, sctx, game, gctx, terrainCanvas, terrainCtx };
}

export function resizeRenderer(r: Renderer) {
  const dpr = window.devicePixelRatio || 1;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  // Letterbox: largest scale that fits both axes
  const scale = Math.min(vw / GAME_W, vh / GAME_H);
  const cssW = Math.floor(GAME_W * scale);
  const cssH = Math.floor(GAME_H * scale);
  r.screen.style.width = cssW + 'px';
  r.screen.style.height = cssH + 'px';
  r.screen.width = Math.floor(cssW * dpr);
  r.screen.height = Math.floor(cssH * dpr);
  // CRITICAL: setting canvas.width resets context state, including imageSmoothingEnabled
  r.sctx.imageSmoothingEnabled = false;
}
